import { Text } from '@fluentui/react/lib/Text';
import ACCESS_DENIED from "../../assets/access-denied.png";
import "./index.css";

const AccessDenied = () => {
  return (
    <div className='Caccess-container'>
      <img
        src={ACCESS_DENIED}
        alt="In Progress" height={'100px'} width={'100px'}
      />
      <Text variant='xLarge' nowrap block>
        Access Denied
      </Text>
      <Text variant='mediumPlus' nowrap block className='Cpaddingtop10'>
      You don't have permission to access this page.
      </Text>
    </div>
  );
};

export default AccessDenied;
